import { GeneralService, CheckoutService } from "@/common/api.service";

// Language / Localization
import LanguageService from "@/common/language.service";

import {
	GET_PAYMENT_METHODS,
	GET_LOCALIZED_RATE,
	GET_FINGERPRINT,
	GET_MERCHANT_CURRENCY,
	GET_CUSTOMER_CURRENCY,
	GET_ORDER_DETAILS,
	VALIDATE_PACKAGE,
	CREATE_PAYLOAD,
	CHECKOUT,
	CLEAR_PM_AND_RATES_CACHE
} from "./actions.type";
import {
	CALL_START,
	CALL_END,
 	STORE_PAYMENT_METHODS,
	SET_PAYLOAD,
	CLEAR_PAYMENT_METHODS_RESOLVE,
	STORE_RATES,
	STORE_FINGERPRINT,
	STORE_MERCHANT_CURRENCY,
	STORE_CUSTOMER_CURRENCY,
	CLEAR_RATES_RESOLVE
} from "./mutations.type";

const state = {
	isLoading: false,
	Financing: {},
	Fingerprint: null,
	merchant_currency: {
		currency: 'XXX',
		units: 2,
		symbol: ''
	},
	customer_currency: {
		currency: 'XXX',
		units: 2,
		symbol: ''
	},
	RateOffer: {
		Country: "",
		Currency: "",
		RateOffer: {
			Expiry: "",
			Id: "",
			Rate: 1
		},
		Symbol: "$",
		Units: 2
	},
	PaymentMethods: [],

	// GENERATED STATE DATA
	payload: {}
};


const getters = {
	get_fingerprint: state => state.Fingerprint,
	financing_options: state => state.Financing,
	paymentMethods: state => state.PaymentMethods,
	rateOffer: state => state.RateOffer,
	merchant_currency: function(state){
		var currdata = {
			'currency': (state.merchant_currency.currency !== undefined ? state.merchant_currency.currency : 'XXX'),
			'symbol': (state.merchant_currency.symbol !== undefined ? state.merchant_currency.symbol : ''),
			'units': (state.merchant_currency.units !== undefined ? state.merchant_currency.units : 2)
		};
		return currdata;
	},
	consumer_currency: function(state){
		return {
			'currency': (state.customer_currency.currency !== undefined ? state.customer_currency.currency : 'XXX'),
			'symbol': (state.customer_currency.symbol !== undefined ? state.customer_currency.symbol : ''),
			'units': (state.customer_currency.units !== undefined ? state.customer_currency.units : 2)
		};
	},

	// Generated totals
	RATE_processing_fee: function(state, getters, rootState, rootGetters){
		// First check if merchant supports collection of fees
		if(!rootGetters.merchant.CollectFees) return 0;

		// Otherwise, continue and set default key
		var pay_id_key = "Default";

		// Try specific payment method
		if(rootGetters.fees[rootGetters.payment_method.Class] !== undefined) {
			pay_id_key = rootGetters.payment_method.Class;
		}
		// Then try general method
		else if(rootGetters.fees[rootGetters.payment_method.Id] !== undefined) {
			pay_id_key = rootGetters.payment_method.Id;
		}
		return rootGetters.fees[pay_id_key];
	},
	AMOUNT_subtotal: function(state, getters, rootState, rootGetters){
		if(rootGetters.invoice.amount_payable){
			return rootGetters.invoice.amount_payable.toFixed(rootGetters.rateOffer.Units);
		}else{
			return (rootGetters.invoice.amount * rootGetters.rateOffer.RateOffer.Rate).toFixed(rootGetters.rateOffer.Units);
		}
	},
	AMOUNT_finance_fees: function(state, getters, rootState, rootGetters){
		// Returns finance fees based on sub total
		if(rootGetters.financing_selected.Number === undefined || rootGetters.financing_selected.Number < 2){
			return 0;
		} else {
			return (rootGetters.AMOUNT_subtotal * rootGetters.financing_selected.Rate).toFixed(rootGetters.rateOffer.Units);
		}
	},
	AMOUNT_processing_fees: function(state, getters, rootState, rootGetters){
		var pre_total = (1*rootGetters.AMOUNT_subtotal) + (1*rootGetters.AMOUNT_finance_fees);
		// Return processing fee
		return ((pre_total * rootGetters.RATE_processing_fee) + (1*rootGetters.AMOUNT_static_processing_fees)).toFixed(rootGetters.rateOffer.Units);
	},
	AMOUNT_static_processing_fees: function(state, getters, rootState, rootGetters){
		// First check if merchant supports collection of fees
		if(!rootGetters.merchant.CollectFees) return 0;

		// Otherwise, continue and set default key
		var pay_id_key = "Default";

		// Try specific payment method
		if(rootGetters.static_fees[rootGetters.payment_method.Class] !== undefined) {
			pay_id_key = rootGetters.payment_method.Class;
		}
		// Then try general method
		else if(rootGetters.static_fees[rootGetters.payment_method.Id] !== undefined) {
			pay_id_key = rootGetters.payment_method.Id;
		}
		return (rootGetters.static_fees[pay_id_key] * rootGetters.rateOffer.RateOffer.Rate).toFixed(rootGetters.rateOffer.Units);
	},
	AMOUNT_total: function(state, getters, rootState, rootGetters){
		// Add up subtotal & all additional fees, then format
		return ((1*rootGetters.AMOUNT_subtotal)
				+ (1*rootGetters.AMOUNT_finance_fees)
				+ (1*rootGetters.AMOUNT_processing_fees)
			).toFixed(rootGetters.rateOffer.Units);
	}
};

const actions = {
	// Build payload -- Depending on params, we want to build this in different
	// ways (ex, no stash, Return url)
	[CREATE_PAYLOAD](context, params) {
		return new Promise((resolve, reject) => {

			var subtotal = ( context.rootState.invoice.invoice.amount * context.state.RateOffer.RateOffer.Rate )
							.toFixed(context.state.RateOffer.Units);

			// Define the basic payload object that every checkout WILL have
			let payload_object = {
				type: "checkout",
				MerchantId: context.rootState.merchant.merchant.MerchantId,
				Source: location.host,
				ConsumerCurrency: context.state.RateOffer.Currency,
				RateOfferId: context.state.RateOffer.RateOffer.Id,
				Items: [
					{
						Sku: "Invoice",
						Quantity: 1,
						Description: context.rootState.invoice.invoice.id,
						ConsumerPrice: context.getters.AMOUNT_subtotal
					},
					{
						Sku: "Fees",
						Quantity: 1,
						Description: "Processing Fees",
						ConsumerPrice: context.getters.AMOUNT_processing_fees
					}
				],
				Capture: true,
				ReferenceId: context.rootState.invoice.invoice.id,
				Consumer: context.rootState.invoice.billing_address,
				PaymentMethod: context.rootState.invoice.payment_method.Id,
				DeviceFingerprint: context.state.Fingerprint

			};

			// If the issuer has been selected, add it (regardless of PM class)
			if(context.rootState.invoice.issuer.length > 0){
				payload_object.IssuerId = context.rootState.invoice.issuer;
			}

			// Add type specific details
			payload_object.subType = context.rootState.invoice.payment_method.Class;
			switch(context.rootState.invoice.payment_method.Class){
				case 'Card':
					// Add stash if its a card
					payload_object.StashId = context.rootState.invoice.stashed.StashId;
					break;
				case 'Offline':
					// If we required an issuer, set it here
					break;
				case 'Online':
					// Add Return url to anything that might route off
					break;
			}

			// If VIAAgent is set, pass it on to checkout
			if(context.rootState.merchant.merchant.ViaAgent) {
				payload_object.ViaAgent = true;
			}

			// Always add Return url
			payload_object.Return = `${location.protocol}//${location.host}/online`;

			// Add financing details
			if(context.rootState.invoice.financing_selected.Number !== undefined){
				// Find total fee amount (by rate & total)
				var financing_fees = subtotal * context.rootState.invoice.financing_selected.Rate;
				payload_object.Financing = {
					Instalments: context.rootState.invoice.financing_selected.Number,
					ConsumerPrice: context.getters.AMOUNT_finance_fees
				};
			}

			context.commit(SET_PAYLOAD, payload_object);
			resolve();
		});
	},
	[CHECKOUT](context, params){
		return new Promise((resolve, reject) => {
			//Generate payload
			context.dispatch(CREATE_PAYLOAD).then(() => {
				// Request payload & signature from server
				GeneralService.verify_checkout(context.state.payload)
				.then( data => {
					// We are going to take the generated payload & generated signature and send them off
					// With the collected card adata
					CheckoutService.checkout({
						request: data.data.payload,
						signature: data.data.signature,
					})
					.then( data => resolve(data) )
					.catch(error => {
						// Checkout Failure! Show error
						var error_message = '';
						if(error.response !== undefined && error.response.data !== undefined){
							error_message = error.response.data;
						} else {
							error_message = LanguageService.getError('GenericError');
						}
						reject(error_message);
					});
				})
				.catch(error => {
					// Signature Failure! Show error
					var error_message = '';
					if(error.response !== undefined && error.response.data !== undefined){
						error_message = error.response.data;
					} else {
						error_message = LanguageService.getError('GenericError');
					}
					reject(error_message);
				});
			});
		});
	},
	[VALIDATE_PACKAGE](context, params){
		//return params;
		return new Promise((resolve, reject) => {
			// Build our signable payload
			var payload = {
				type: "validate",
				MerchantId: context.rootState.merchant.merchant.MerchantId,
				Source: location.host,
				payload: params.package,
				signature: params.signature
			};
			// Request payload & signature from server
			GeneralService.verify_checkout(payload)
			.then( data => {
				resolve(data.data);
			}).catch( error => resolve(error) );
		});
	},
	[GET_ORDER_DETAILS](context, params){
		//return params;
		return new Promise((resolve, reject) => {
			// Build our signable payload
			var payload = {
				type: "query",
				MerchantId: context.rootState.merchant.merchant.MerchantId,
				Source: location.host,
				OrderId: params
			};

			// Request payload & signature from server
			GeneralService.verify_checkout(payload)
			.then( data => {
				// We are going to take the generated payload & generated signature and send them off
				// With the collected card adata
				CheckoutService.query({
					request: data.data.payload,
					signature: data.data.signature,
				})
				.then( data => {
					// Handle query success
					try{
						// Parse the order query data
						var query = parseQuery(data.data);
						var response = JSON.parse(query.response);
					}catch(err){
						reject(LanguageService.getError('ServerError'));
						return;
					}
					// Process the order data
					resolve(response);
				})
				.catch(error => {
					// Checkout Failure! Show error
					if(error.response !== undefined && error.response.data !== undefined){
						reject(error.response.data);
					} else {
						reject(LanguageService.getError('GenericError'));
					}
				});
			})
			.catch(error => {
				// Signature Failure! Show error
				reject(error.response.data);
			});
		});
	},
	[GET_MERCHANT_CURRENCY]({ commit }, params) {
		console.log(params);
		// Hit up the Fingerprint service and store the fingerprint
		return new Promise((resolve, reject) => {
			CheckoutService.getCurrencies(params)
			.then(({ data }) => {
				console.log("Store merch currency");
				commit(STORE_MERCHANT_CURRENCY, { 'data': data, 'currency': params.Currency});
				resolve();
			})
			.catch(error => {
				// Do nothing, empty currency list will default to
				// generic formatting
				console.log(error);
				resolve();
			});
		});
	},
	[GET_CUSTOMER_CURRENCY]({ commit }, params) {
		// Hit up the Fingerprint service and store the fingerprint
		return new Promise((resolve, reject) => {
			CheckoutService.getCurrencies(params)
			.then(({ data }) => {
				commit(STORE_CUSTOMER_CURRENCY, { 'data': data, 'currency': params.Currency});
				resolve();
			})
			.catch(error => {
				// Do nothing, empty currency list will default to
				// generic formatting
				console.log(error);
				resolve();
			});
		});
	},
	[GET_FINGERPRINT]({ commit }, params) {
		// Hit up the Fingerprint service and store the fingerprint
		return new Promise((resolve, reject) => {
			CheckoutService.getFingerprint({
				MerchantId: params.MerchantId
			})
			.then(({ data }) => {
				commit(STORE_FINGERPRINT, data);
				resolve();
			})
			.catch(error => {
				reject(LanguageService.getError('FingerprintError'));
			});
		});
	},
	// Pay method call happens in the backround - no promise required
	[GET_PAYMENT_METHODS]({ commit }, params) {
		//commit(CALL_START);
		return new Promise((resolve, reject) => {
			CheckoutService.getPaymentMethods(params)
			.then(({ data }) => {
				commit(STORE_PAYMENT_METHODS, data);
				resolve();
			})
			.catch(error => {
				// Frontend will handle it
				reject(LanguageService.getError('NoPaymentMethods'))
			});
		});
	},
	// Rate offer call happens in the backround - no promise required
	[GET_LOCALIZED_RATE]({ commit }, {MerchantId, Country}) {
		//commit(CALL_START);
		return CheckoutService.getPaymentRate({
			MerchantId,
			Country,
			IncludeRate: true
		})
		.then(({ data }) => {
			commit(STORE_RATES, data);
		})
		.catch(() => {
			// Frontend will handle it
		});
	},
	[CLEAR_PM_AND_RATES_CACHE]({ commit }) {
		commit(CLEAR_PAYMENT_METHODS_RESOLVE);
		commit(CLEAR_RATES_RESOLVE);
	},
};

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
	[SET_PAYLOAD](state, payload) {
		state.payload = payload;
	},
	[STORE_FINGERPRINT](state, data){
		//execute JS, then store Fingerprint
		if (window.execScript) window.execScript(data); //ie
		else top.eval(data); //others

		state.Fingerprint = gip_device_fingerprint;
		state.isLoading = false;
	},
	[STORE_MERCHANT_CURRENCY](state, data){
		console.log('storing merchant currency');
		state.merchant_currency = data.data[data.currency];
		state.merchant_currency.currency = data.currency;
	},
	[STORE_CUSTOMER_CURRENCY](state, data){
		console.log("storing customer currency");
		state.customer_currency = data.data[data.currency];
		state.customer_currency.currency = data.currency;
	},
	[CLEAR_PAYMENT_METHODS_RESOLVE](state, data){
		state.Financing = {};
		state.PaymentMethods = [];
		state.isLoading = false;
	},
	[STORE_PAYMENT_METHODS](state, data){
		state.Financing = data.Financing || {};
		state.PaymentMethods = data.PaymentMethods || [];
		state.isLoading = false;
	},
	[CLEAR_RATES_RESOLVE](state, data){
		state.RateOffer = {
			Country: "",
			Currency: "",
			RateOffer: {
				Expiry: "",
				Id: "",
				Rate: 1
			},
			Symbol: "$",
			Units: 2
		};
		state.isLoading = false;
	},
	[STORE_RATES](state, data){
		state.RateOffer = data;
		state.isLoading = false;
	}
};

export default {
	state,
	getters,
	actions,
	mutations
};
